export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon',
      },
      {
        title: 'Branch',
        route: 'branch',
        icon: 'FileIcon',
      },
      {
        title: 'Empresa',
        route: 'empresa',
        icon: 'FileIcon',
      },
    ],
  },
]
